/*! rb-pci-cookie-guard-v1 — force Secure+SameSite on client-set cookies (esp. localization) */
(function () {
  'use strict';
  if (typeof document === 'undefined') return;
  if (window.__rbPciCookieGuard) return;
  window.__rbPciCookieGuard = true;

  var proto = Document.prototype;
  var desc =
    Object.getOwnPropertyDescriptor(proto, 'cookie') ||
    Object.getOwnPropertyDescriptor(HTMLDocument.prototype, 'cookie');
  if (!desc || !desc.set || !desc.get) return;

  var nativeSet = desc.set;
  var nativeGet = desc.get;

  function harden(val) {
    if (typeof val !== 'string' || !val) return val;
    var out = val;
    if (!/;\s*secure/i.test(out) && (location.protocol === 'https:' || location.hostname === 'localhost')) {
      out = out.replace(/;?\s*$/, '') + '; Secure';
    }
    if (!/;\s*samesite=/i.test(out)) {
      out = out.replace(/;?\s*$/, '') + '; SameSite=Lax';
    }
    if (!/;\s*path=/i.test(out)) {
      out = out.replace(/;?\s*$/, '') + '; Path=/';
    }
    return out;
  }

  Object.defineProperty(document, 'cookie', {
    configurable: true,
    enumerable: true,
    get: function () {
      return nativeGet.call(document);
    },
    set: function (val) {
      return nativeSet.call(document, harden(val));
    },
  });

  /* Refresh localization with Secure if it already exists without it */
  try {
    var match = document.cookie.match(/(?:^|; )localization=([^;]*)/);
    if (match) {
      document.cookie =
        'localization=' +
        match[1] +
        '; Path=/; Max-Age=31536000; Secure; SameSite=Lax';
    }
  } catch (e) {}
})();
